import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import AddressFieldset from '#client/components/AddressFieldset';

const fieldsConfig = {
  address1: { show: true },
  address2: { show: true },
  city: { show: true },
  state: { show: true },
  postalCode: { show: true }
};

function EditView({ sectionKey }) {
  // TODO: translate strings
  const tooltip = 'The business mailing address is where the state will send any correspondence.';

  return (
    <>
      <Text component="p">{tooltip}</Text>
      <AddressFieldset fieldsConfig={fieldsConfig} namePrefix={sectionKey} />
    </>
  );
}

EditView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default EditView;
